<div class="card">
  <div class="flex items-center gap-2 mb-2">
    <span class="pill">{{contextType | customerText}}</span>
    <div>
      <p class="label">{{subtitle | customerText}}</p>
      <h3 class="font-semibold text-base">{{title}}</h3>
    </div>
  </div>
  <p class="text-sm text-grey-800 mb-2">{{body | customerText}}</p>
  <p class="text-xs text-grey-600">{{meta | customerText}}</p>
</div>
